// Mock data for Pro-Wash Mobile Detailing

export const businessInfo = {
  name: "Pro-Wash Mobile Detailing",
  tagline: "Serving the Lower Mainland | We come to you!",
  subtitle: "Premium mobile car detailing for that new car feel.",
  phone: "(604) 613-8901",
  email: "info@prowashmd.com",
  instagram: "@prowashmobiledetailing",
  facebook: "Pro-Wash Mobile Detailing",
  instagramUrl: "https://www.instagram.com/prowashmobiledetailing/",
  facebookUrl: "https://www.facebook.com/profile.php?id=61575967916296"
};

export const services = [
  {
    id: 1,
    name: "Full Detail Package",
    price: 299,
    duration: "Up to 4 hours",
    description: "Our flagship all-inclusive service that restores that 'new car feel'",
    features: [
      "Foam pre-soak & hand wash",
      "High-pressure rinse",
      "Steam cleaning door jambs", 
      "6-12 month ceramic wax coating",
      "Wheel deep clean & tire dressing",
      "Carpet, seat, & upholstery cleaning",
      "Leather and plastic conditioning",
      "Commercial steam cleaning",
      "Streak-free glass cleaning"
    ],
    popular: true
  },
  {
    id: 2,
    name: "Exterior Detail",
    price: 149,
    duration: "2-3 hours",
    description: "Complete exterior restoration and protection",
    features: [
      "Foam pre-soak & hand wash",
      "High-pressure rinse", 
      "Steam cleaning door jambs",
      "Wheel deep clean & tire dressing",
      "Ceramic wax coating",
      "Streak-free glass cleaning"
    ]
  },
  {
    id: 3,
    name: "Interior Detail", 
    price: 199,
    duration: "2-3 hours",
    description: "Deep interior cleaning and conditioning",
    features: [
      "Carpet, seat, & upholstery cleaning",
      "Leather and plastic conditioning", 
      "Commercial steam cleaning",
      "Streak-free glass cleaning",
      "Odor elimination",
      "Dashboard & console detailing"
    ]
  },
  {
    id: 4,
    name: "Motorcycle Detail",
    price: 199,
    duration: "2-3 hours", 
    description: "Specialized motorcycle detailing service",
    features: [
      "Complete exterior wash",
      "Chrome & metal polishing",
      "Leather seat conditioning",
      "Engine bay cleaning",
      "Protective wax application"
    ]
  }
];

export const ceramicCoatings = [
  {
    id: 'ceramic-8year',
    name: "8-Year Signature Ceramic Coating",
    brand: "Crystal Brite",
    basePriceRegular: 799,
    basePriceLifted: 848,
    duration: "Full day service",
    description: "Crystal Brite Semi-Permanent Coating with single stage machine polish — 6-8 years of premium 9H protection",
    features: [
      "Single stage machine polish",
      "Crystal Brite Semi-Permanent Coating",
      "9H hardness — superior UV & scratch protection",
      "Insane hydrophobic water beading",
      "High-definition shine + self-cleaning properties",
      "Exterior only (no interior)"
    ],
    popular: true
  }
];

export const ceramicInteriorBundle = {
  id: 'interior-bundle',
  name: "Interior Deep Clean Bundle",
  price: 199,
  description: "Complete interior detailing add-on for ceramic coating packages",
  features: [
    "Full interior deep clean",
    "Carpet & upholstery shampooing",
    "Leather conditioning",
    "Dashboard & console detailing",
    "Streak-free glass cleaning",
    "Odor elimination treatment"
  ]
};

export const addOns = [
  {
    id: 1,
    name: "Engine Bay Cleaning",
    price: 49,
    description: "Deep clean and detail engine compartment"
  },
  {
    id: 2,
    name: "Pet Hair Removal", 
    price: 49,
    description: "Specialized treatment for pet-related issues"
  },
  {
    id: 3,
    name: "Heavy Stain/Mold Removal",
    price: 49,
    description: "Intensive stain and mold removal"
  },
  {
    id: 4,
    name: "Odor Removal",
    price: 49,
    description: "Professional odor elimination treatment"
  }
];

export const serviceAreas = [
  "Abbotsford (Central, Clearbrook, Matsqui, Sumas, Bradner, Mount Lehman, Hatzic)",
  "Surrey (Cloverdale, Fleetwood, Guildford, Newton, Whalley, South Surrey)",
  "White Rock (East Beach, West Beach)",
  "Langley (Aldergrove, Brookswood, Fort Langley, Murrayville, Walnut Grove, Willoughby)",
  "Mission (Downtown, Silverdale, Hatzic, Stave Falls)",
  "Maple Ridge (Albion, Haney, Silver Valley, Whonnock)",
  "Pitt Meadows (Central, North)"
];

export const testimonials = [
  {
    id: 1,
    name: "Stefano D'Emilio",
    location: "Abbotsford",
    rating: 5,
    text: "Tristen made my '81 Cadillac showroom-ready for my wedding. Immaculate results, incredible attention to detail. Highly recommend!",
    service: "Full Detail Package",
    source: "Google"
  },
  {
    id: 2,
    name: "Scott Barratt",
    location: "Abbotsford", 
    rating: 5,
    text: "Tristen tackled a messy backseat situation and left our car spotless. Amazing wheel treatment, polished every crevice. 10/5 stars!",
    service: "Full Detail Package",
    source: "Google"
  },
  {
    id: 3,
    name: "John David Uy",
    location: "Abbotsford",
    rating: 5,
    text: "Thorough interior/exterior detail. Tires and leather look brand new, great value for ceramic wax. Perfect price!",
    service: "Full Detail Package",
    source: "Google"
  },
  {
    id: 4,
    name: "Chelsey Gee",
    location: "Mission",
    rating: 5,
    text: "As a mom of three, I'm thrilled with Tristan's prompt, thorough service. Excellent communication. Will book again!",
    service: "Interior Detail",
    source: "Google"
  },
  {
    id: 5,
    name: "Richard Coombs",
    location: "Langley",
    rating: 5,
    text: "Mind-blowing shine, got all dog hair out. Best price and professional service!",
    service: "Full Detail Package",
    source: "Google"
  },
  {
    id: 6,
    name: "Jeff Keetley",
    location: "Surrey",
    rating: 5,
    text: "Top-quality service and work ethic. Best value in the Lower Mainland. 5 stars all the way!",
    service: "Exterior Detail",
    source: "Facebook"
  }
];

export const galleryImages = [
  {
    id: 1,
    type: 'video',
    url: "https://customer-assets.emergentagent.com/job_sparkle-auto-14/artifacts/10zrr8mo_20250720_134155%20%281%29%20%28online-video-cutter.com%29.mp4",
    title: "Professional Detailing",
    description: "Premium car detailing in action"
  },
  {
    id: 2,
    type: 'video',
    url: "https://customer-assets.emergentagent.com/job_sparkle-auto-14/artifacts/0t99dmqn_20240812_125719_1.mp4",
    title: "Interior Cleaning",
    description: "Deep interior restoration"
  },
  {
    id: 3,
    type: 'video',
    url: "https://customer-assets.emergentagent.com/job_sparkle-auto-14/artifacts/5m7juumg_20250719_140214%20%282%29%20%28online-video-cutter.com%29.mp4",
    title: "Exterior Detail",
    description: "Ceramic wax coating application"
  },
  {
    id: 4,
    type: 'video',
    url: "https://customer-assets.emergentagent.com/job_sparkle-auto-14/artifacts/vmbflj6q_20240826_150455_1.mp4",
    title: "Wheel Treatment",
    description: "Professional wheel detailing"
  },
  {
    id: 5,
    type: 'video',
    url: "https://customer-assets.emergentagent.com/job_sparkle-auto-14/artifacts/zlkxjk45_20240731_132259.mp4",
    title: "Final Results",
    description: "Transformation complete"
  },
  {
    id: 6,
    type: 'video',
    url: "https://customer-assets.emergentagent.com/job_sparkle-auto-14/artifacts/jyvfgnkk_20240724_123813.mp4",
    title: "Premium Results", 
    description: "Professional detailing showcase"
  }
];

export const bookingSlots = [
  { id: 1, time: "8:00 AM", available: true },
  { id: 2, time: "1:00 PM", available: true }
];

export const faqData = [
  {
    id: 1,
    question: "What does your Full Detail Package include?",
    answer: "Our Full Detail Package is designed to restore and protect your vehicle with a balance of deep cleaning and 6-month ceramic wax protection.\n\nExterior Restoration & Protection: Decontamination Wash (multi-stage foam pre-soak and scratch-free hand wash), High-Pressure Rinse (wheel wells and undercarriage), Steam-Cleaned Door Jambs (including trunk and gas cap areas), Hand-Applied Ceramic Protection (6-month ceramic wax for superior water beading, UV resistance, and deep-gloss finish), Precision Wheel & Tire Care (deep cleaning with matte-finish tire dressing), and Optical Glass Clarity.\n\nInterior Deep Clean & Sanitize: Thermal Steam Disinfection (commercial-grade treatment without harsh chemicals), Complete Interior Detail (dashboard, console, door panels with UV protection), Upholstery & Carpet Extraction (deep-vacuuming and targeted stain removal), and Premium Trim Conditioning (leather and vinyl restored to factory-matte finish).\n\nService Duration: Approximately 4 hours."
  },
  {
    id: 2,
    question: "Which areas do you provide mobile detailing services?",
    answer: "Pro-Wash is a fully mobile detailing service based in Abbotsford, BC. We prioritize our local clients in Abbotsford, but also serve Langley, Maple Ridge and beyond."
  },
  {
    id: 3,
    question: "What is the difference between your Ceramic Wax and your 8-Year Signature Ceramic Coating?",
    answer: "The difference is in the chemistry and the preparation. Our Ceramic Wax ($299) is a high-solids SiO2 sealant designed for 6 months of seasonal protection and high-gloss maintenance. Our flagship 8-Year Signature Ceramic Coating uses Crystal Brite Semi-Permanent Coating with 9H hardness, applied over a single stage machine polish that removes swirls and oxidation. The result: 6-8 years of premium protection, insane hydrophobics, high-definition shine, and self-cleaning properties."
  },
  {
    id: 4,
    question: "Do your automotive ceramic coatings come with a warranty?",
    answer: "Yes. Our 8-Year Signature Ceramic Coating (Crystal Brite Semi-Permanent) includes protection against environmental staining and oxidation. Because we perform a single stage machine polish before application, the 9H coating forms a durable bond with your vehicle's clear coat for long-lasting protection. A garage or covered workspace is required for proper curing."
  },
  {
    id: 5,
    question: "Do you offer mobile detailing for motorcycles and boats?",
    answer: "Yes. We offer a specialized Motorcycle Detail for $199, which includes a full wash, engine bay degreasing, and chrome/metal polishing. For Boats, we provide custom on-site quotes based on the hull's length and gelcoat condition."
  },
  {
    id: 6,
    question: "What payment methods do you accept, and is a deposit required?",
    answer: "We accept Credit/Debit, Apple Pay, Google Pay, E-transfer, and Cash. To keep the booking process efficient for our Abbotsford clients, no deposits are required. Payment is only due upon the successful completion of the service and your total satisfaction."
  }
];